export default "__VITE_ASSET__ChyGSP1a__"